export default __webpack_public_path__ + "static/media/rain.0b103200.svg";